// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"3720cdb2","427":"90b84f94","736":"d0248cc8","899":"1c142249"}[chunkId] + ".chunk.js";
};